export default __webpack_public_path__ + "static/media/pic1.f1d403e5.jpg";